document.addEventListener('DOMContentLoaded', function () {
    const scriptTag = document.getElementById('assembly-service-script')
    var userZip = localStorage.getItem('userZip')
    var assemblyVariantInfo = document.getElementById('assembly-variant-info')
    let assemblyVariantInfoCart = document.getElementById('assembly-info-cart')
    var addButton = document.getElementById('addBothToCartButton')
    const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
    const mainCartWrapper = document.querySelector('.template-cart .cart-section');

    // var assemblyVariantCartBtn = document.getElementById('addAssemblyVariantToCartButton')

    var addAssemblyCheckbox = document.getElementById('addInCartButton')
    let checkAvailabilityButton = document.getElementById(
        'check-assembly-availability'
    )
    var postalCodeInput = document.getElementById('shipping-estimator-zipcode')
    var assemblyAddedinCart = false
    let assemblyVariantId

    //running in shopping cart
    if (scriptTag && scriptTag.getAttribute('data-context') === 'inCart') {
        checkAssemblyVariantInCart().then((assemblyAdded) => {
            if (assemblyAdded) {
                inCartAssemlyToggle(false)
            } else {
                if (addAssemblyCheckbox) {
                    addAssemblyCheckbox.addEventListener(
                        'change',
                        toggleAssemblyInCart
                    )
                }

                const cartAssemblyShown = checkEligibilityInLocalStorage()
                if (cartAssemblyShown) {
                    inCartAssemlyToggle(true)
                } else {
                    const hasLocalDelivery = checkLocalDelivery()
                    if (hasLocalDelivery) {
                        inCartAssemlyToggle(true)
                    }
                }
            }
        })

        monitorShippingDataChanges()
    }

    if (userZip !== 'null') {
        if (postalCodeInput !== null) {
            postalCodeInput.value = userZip
        }
    }

    let showOnEachProduct = checkEligibilityInLocalStorage()
    if (showOnEachProduct) {
        displayAssemblyProduct(false)
    }

    if (checkAvailabilityButton) {
        checkAvailabilityButton.addEventListener('click', async function () {
            let postalCode = normalizeCanadianPostalCode(postalCodeInput.value)
            let postalCodePattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
            if (!postalCode) {
                displayPostalCodeMessage('Enter a postal code.')
                return
            }
            if (!postalCodePattern.test(postalCode)) {
                displayPostalCodeMessage(
                    'Please enter a valid Canadian postal code.'
                )
                return
            }

            postalCodeInput.value = postalCode

            loadingToggle(true)

            const isTheSameZip = checkAndUpdatePostalCode(postalCode)
            if (isTheSameZip) {
                const eligibilityInStorage = checkEligibilityInLocalStorage()
                if (eligibilityInStorage == null) {
                    await checkEligibility(postalCode)
                } else if (eligibilityInStorage) {
                    displayAssemblyProduct(false)
                } else {
                    displayServiceUnavailableError()
                }
            } else {
                await checkEligibility(postalCode)
            }

            setTimeout(() => {
                customToggleAssemblyInCart(customCheckEligibilityInLocalStorage());
            }, 2000);

            // setTimeout(() => {
            //     window.location.reload();
            // }, 500);

        })
    }

    const customToggleAssemblyInCart = (isEligible) => {

        if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
        if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

        // Get main wrappers (safely)
        const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
        const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

        let hasAssemblyMessage = false;

        // --- Process main cart page items ---
        if (mainCartPageWrapper) {
            const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

            itemWrappers.forEach(wrapper => {
                const title = (wrapper.dataset.title || "").toLowerCase();

                if (title.includes("assembly services")) {
                    if (!isEligible) {
                        if (!wrapper.querySelector('.assembly-service-msg')) {
                            const msg = document.createElement('p');
                            msg.className = 'assembly-service-msg';
                            msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                            wrapper.appendChild(msg);
                        }
                        hasAssemblyMessage = true;
                    } else {
                        const existingMsg = wrapper.querySelector('.assembly-service-msg');
                        if (existingMsg) existingMsg.remove();
                    }
                }
            });
        }

        // --- Process cart drawer items ---
        if (mainCartDrawerWrapper) {
            const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

            itemWrappers.forEach(wrapper => {
                const cartItem = wrapper.querySelector('.cart-item');
                if (!cartItem) return;

                const title = (cartItem.dataset.title || "").toLowerCase();

                if (title.includes("assembly services")) {
                    if (!isEligible) {
                        if (!wrapper.querySelector('.assembly-service-msg')) {
                            const msg = document.createElement('p');
                            msg.className = 'assembly-service-msg';
                            msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                            wrapper.appendChild(msg);
                        }
                        hasAssemblyMessage = true;
                    } else {
                        const existingMsg = wrapper.querySelector('.assembly-service-msg');
                        if (existingMsg) existingMsg.remove();
                    }
                }
            });
        }

        // --- Disable all checkout buttons if needed ---
        const checkoutBtns = document.querySelectorAll('button#CheckOut');
        checkoutBtns.forEach(btn => {
            btn.disabled = hasAssemblyMessage;
            btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
            btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
        });
    };

    const customCheckEligibilityInLocalStorage = () => {
        const eligibility = localStorage.getItem('eligibility');
        return eligibility?.toLowerCase() === 'true' ? true
            : eligibility?.toLowerCase() === 'false' ? false
            : null;
    };

    if (addButton) {
        addButton.addEventListener('click', addAssemblyToCart)
    }


    //function
    async function checkAssemblyVariantInCart() {
        try {
            let isAssemblyAdded = false
            const response = await fetch('/cart.js')
            const cart = await response.json()

            document
                .querySelectorAll('[data-cart-item-id]')
                .forEach(function (element) {
                    const variantInfoElement =
                        element.querySelector('#variantInfoInCart')
                    const gid = variantInfoElement.getAttribute('data-assembly')
                    const assemblyVariantId = gid.split('/').pop()

                    const isAssemblyInCart = cart.items.some(
                        (item) => item.id.toString() === assemblyVariantId
                    )

                    if (isAssemblyInCart) {
                        element.style.display = 'none'
                        isAssemblyAdded = true
                    } else {
                        element.style.display = 'block'
                    }
                })

            return isAssemblyAdded
        } catch (error) {
            console.error(error)
            return isAssemblyAdded
        }
    }

    function checkAndUpdatePostalCode(postalCode) {
        userZip = localStorage.getItem('userZip')

        if (postalCode !== userZip) {
            localStorage.setItem('userZip', postalCode)
            return false
        } else {
            return true
        }
    }

    function normalizeCanadianPostalCode(postalCode) {
        if (!postalCode) {
            return ''
        }

        const compact = postalCode.toString().replace(/\s+/g, '').toUpperCase()
        if (compact.length === 6) {
            return `${compact.slice(0, 3)} ${compact.slice(3)}`
        }

        return postalCode.toString().trim().toUpperCase()
    }

    function waitForGoogleMapsApi(timeout = 5000) {
        if (
            window.__assemblyMapsApiReady ||
            (window.google &&
                window.google.maps &&
                window.google.maps.Geocoder)
        ) {
            return Promise.resolve(true)
        }

        return new Promise((resolve) => {
            const startedAt = Date.now()
            const interval = setInterval(() => {
                const apiReady =
                    window.google &&
                    window.google.maps &&
                    window.google.maps.Geocoder

                if (apiReady) {
                    clearInterval(interval)
                    resolve(true)
                    return
                }

                if (Date.now() - startedAt >= timeout) {
                    clearInterval(interval)
                    resolve(false)
                }
            }, 100)
        })
    }

    function checkEligibilityInLocalStorage() {
        let eligibility = localStorage.getItem('eligibility')

        if (eligibility !== null && eligibility !== 'null') {
            if (eligibility.toLowerCase() === 'true') {
                return true
            } else if (eligibility.toLowerCase() === 'false') {
                return false
            }
        }
        return null
    }

    function setEligibilityInLocalStorage(value) {
        localStorage.setItem('eligibility', value)
    }

    function haversineDistanceKm(lat1, lon1, lat2, lon2) {
        const toRadians = (degrees) => (degrees * Math.PI) / 180
        const earthRadiusKm = 6371
        const dLat = toRadians(lat2 - lat1)
        const dLon = toRadians(lon2 - lon1)
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) *
                Math.cos(toRadians(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2)
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        return earthRadiusKm * c
    }

    function geocodePostalCode(postalCode) {
        return new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder()
            geocoder.geocode(
                {
                    address: `${postalCode}, Canada`,
                    componentRestrictions: { country: 'CA' },
                    region: 'CA',
                },
                (results, status) => {
                    if (
                        status === 'OK' &&
                        results &&
                        results.length > 0 &&
                        results[0].geometry &&
                        results[0].geometry.location
                    ) {
                        resolve(results[0].geometry.location)
                        return
                    }
                    reject({ type: 'GEOCODER_ERROR', code: status })
                }
            )
        })
    }

    async function calculateDistanceFallback(destinationPostalCode) {
        // Approximate driving distance from straight-line distance so transient Matrix API issues don't block checkout.
        const originLat = 43.76977
        const originLng = -79.48774
        const destinationLocation = await geocodePostalCode(destinationPostalCode)
        const directDistanceKm = haversineDistanceKm(
            originLat,
            originLng,
            destinationLocation.lat(),
            destinationLocation.lng()
        )
        const estimatedDrivingDistanceKm = directDistanceKm * 1.3
        return estimatedDrivingDistanceKm <= 200
    }

    function calculateDistance(destinationPostalCode) {
        return calculateDistanceFallback(destinationPostalCode)
    }

    async function checkEligibility(destinationPostalCode) {
        try {
            const mapsApiReady = await waitForGoogleMapsApi()
            if (!mapsApiReady) {
                loadingToggle(false)
                displayPostalCodeMessage(
                    'Assembly lookup is unavailable right now. Please try again in a few minutes and make sure blockers are disabled.'
                )
                return
            }

            const isWithin200Km = await calculateDistance(destinationPostalCode)

            let eligibilityCheck
            if (isWithin200Km) {
                displayAssemblyProduct(false)
                eligibilityCheck = true
            } else {
                displayServiceUnavailableError()
                eligibilityCheck = false
            }
            setEligibilityInLocalStorage(eligibilityCheck)
        } catch (error) {
            if (error && error.code === 'OVER_QUERY_LIMIT') {
                displayNoAssmemblyError()
                return
            }

            displayUnexpectedError()
        }
    }

    async function displayAssemblyProduct(IsCart) {
        var variantInfoElement = IsCart
            ? document.getElementById('variantInfoInCart')
            : document.getElementById('variantInfo')
        if (!variantInfoElement) {
            return
        }

        var gid = variantInfoElement.getAttribute('data-assembly')
        var variantId = gid.split('/').pop()

        const assemblyVariantListing = await fetchVariantDetails(variantId)

        if (assemblyVariantListing) {
            let assemblyInnerHtml = `<span> Add Assembly Service for $${assemblyVariantListing.formattedPrice} </span>`
            if (IsCart && assemblyVariantInfoCart) {
                assemblyVariantInfoCart.innerHTML = assemblyInnerHtml
            } else {
                assemblyVariantInfo.innerHTML = assemblyInnerHtml
                addtoCartToggle(true)
                loadingToggle(false)
            }
        } else {
            displayNoAssmemblyError()
        }
    }

    async function fetchVariantDetails(variantId) {
        try {
            const response = await fetch(`/variants/${variantId}.js`)
            if (!response.ok) {
                displayUnexpectedError()
                return
            }
            const variant = await response.json()
            assemblyVariantId = variant.id
            return {
                title: variant.title,
                formattedPrice: (variant.price / 100).toFixed(2),
            }
        } catch (_error) {
            displayNoAssmemblyError()
            return null
        }
    }

    function toggleAssemblyInCart() {
        const isChecked = addAssemblyCheckbox.checked
        if (assemblyVariantInfoCart) {
            assemblyVariantInfoCart.style.display = 'block'
        }
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const item = cart.items.find(
                    (item) =>
                        item.id.toString() === assemblyVariantId.toString()
                )

                if (!item && isChecked) {
                    addItemToCart()
                        .then(() => {
                            assemblyAddedinCart = true
                            updateCartContents()
                        })
                        .catch((error) => {
                            console.error(
                                'Error adding assembly service to cart:',
                                error
                            )
                            assemblyAddedinCart = false
                            displayCartAdditionError()
                            addAssemblyCheckbox.checked = false
                        })
                }
            })
            .catch((error) => {
                console.error('Error fetching cart:', error)
                displayCartAdditionError()
                addAssemblyCheckbox.checked = !addAssemblyCheckbox.checked
            })
    }

    function addItemToCart() {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: [{ quantity: 1, id: assemblyVariantId }],
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to add item to cart')
                }
                return response.json()
            })
            .catch((error) => {
                console.error('Error adding item to cart:', error)
                displayCartAdditionError()
            })
    }

    function addAssemblyToCart() {
        addItemToCart().then(() => {
            updateCartContents({ showOverlay: true })


        })
    }

    function _updateCartQty(item, newQty){

        let alert = null;

        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                cartItems.ajaxifyCartItems();

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        const _form = cartItemsContainer.querySelector('form');

        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.updateCartQty(item, 0); // Assuming you have updateCartQty defined elsewhere
  
                });
            }

        });
    }

    function updateCartContents({ showOverlay = false } = {}) {

        fetch('?section_id=helper-cart')
            .then((response) => response.text())
            .then((text) => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                ajaxifyCartItems(cartItems);

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').form.prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

                // const parser = new DOMParser()
                // const doc = parser.parseFromString(text, 'text/html')
                // const cartForm = doc.getElementById('AjaxCartForm').innerHTML
                // const cartSubtotal =
                //     doc.getElementById('AjaxCartSubtotal').innerHTML

                // document.getElementById('AjaxCartForm').innerHTML = cartForm
                // document.getElementById('AjaxCartSubtotal').innerHTML =
                //     cartSubtotal

                    
                // document
                //     .querySelectorAll('[data-header-cart-count]')
                //     .forEach((element) => {
                //         element.textContent = document.querySelector(
                //             '#AjaxCartForm [data-cart-count]'
                //         ).textContent
                //     })
                // document
                //     .querySelectorAll('[data-header-cart-total]')
                //     .forEach((element) => {
                //         element.textContent = document.querySelector(
                //             '#AjaxCartForm [data-cart-total]'
                //         ).textContent
                //     })

                if (showOverlay) {
                    showCartOverlay()
                }


                        let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

						console.log('Stored cart price from localStorage:', storedCartPrice);

						console.log("Cart successfully updated");

                        // console.log( cartSubtotal , "inside assembly");
                        
                        let subTotalElem =  document.getElementById('AjaxCartSubtotal');
                        if (!subTotalElem) return;

                        let subTotalAmt = subTotalElem.querySelector('.cart__total').getAttribute('data-total-price');
                        console.log('Subtotal amount:', subTotalAmt);
					

						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());
						console.log(isNaN(cartPrice), "cartPrice", cartPrice);

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						console.log(subTotalAmt);

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

                        const _allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            // allSteps.forEach((step, index) => {
							// 	const stepAmount = parseFloat(step.getAttribute("data-amount"));
							// 	if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

							// 	step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

							// 	const productElem = step.querySelector(".product_or_discount");
							// 	if (!productElem) return;

							// 	const type = productElem.getAttribute("data-product-or-discount");
							// 	const productVariantId = productElem.getAttribute("data-product-id");
							// 	const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

							// 	// -----------------------------
							// 	// IF (cartPrice >= stepAmount)
							// 	// -----------------------------
							// 	if (cartPrice >= stepAmount && type === "product") {

							// 		const hasFreeItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) === 0;
							// 		});

							// 		const hasPaidItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) > 0;
							// 		});

							// 		console.log(hasFreeItem, "hasFreeItem (price=0)");
							// 		console.log(hasPaidItem, "hasPaidItem (price>0)");

							// 		// Rule: DO NOT render if a free version already exists
							// 		const shouldRender = !hasFreeItem;

							// 		if (shouldRender) {
							// 			allProductsHTML += `
							// 				<div class="single_step_product_wrapper" id="${wrapperId}">
							// 					<div class="free_product_wrapper_inner">
							// 						${productElem.innerHTML}
							// 					</div>
							// 				</div>`;
							// 		}
							// 	}

							// 	// -----------------------------
							// 	// ELSE (cartPrice < stepAmount)
							// 	// -----------------------------
							// 	else {

							// 		// 1. Remove accordion
							// 		const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
							// 		if (mainAccordion) {
							// 			const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
							// 			if (productWrapper) productWrapper.remove();
							// 		}

							// 		// 2. Remove ONLY free version from cart
							// 		if (type === "product") {

							// 			// Find all matched items
							// 			const matchedItems = cart.items.filter(item => {
							// 				const id = item.id.toString().replace("item-", "");
							// 				return id === productVariantId.toString();
							// 			});

							// 			console.log(matchedItems , "matchedItems in else part") ;

							// 			matchedItems.forEach(item => {

							// 				console.log(item.price , "each item Price in else");
											
							// 				const price = Number(item.price);
							// 				if (price === 0) {
							// 					console.log("Removing free item:", item.id);
							// 					removeProductFromCart(productVariantId);
							// 				} else {
							// 					console.log("Keeping paid item:", item.id);
							// 				}
							// 			});
							// 		}
							// 	}
							// });

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // -----------------------------
                                // IF (cartPrice >= stepAmount)
                                // -----------------------------

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    console.log(hasFreeItem, "hasFreeItem (price=0)");
                                    console.log(hasPaidItem, "hasPaidItem (price>0)");

                                    // If ANY variant exists → do NOT render
                                    // const shouldRender = !hasFreeItem && !hasPaidItem;
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }


                                else {

                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }

                                        // 2. Remove only free variant from cart
                                        if (type === "product") {

                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            

                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    console.log("Removing free item:", item.variant_id);
                                                    removeProductFromCart(item.variant_id);
                                                } else {
                                                    console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                                });

							

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">Free Gift</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       


							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}

						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();



						// Filled bar
						if (!isNaN(cartPrice)) {

							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";
							}
						}

						// subtotalAmt Updated

						console.log(subTotalAmt);

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);



            })
            .catch((error) => {
                console.error('Error updating cart contents:', error)
                displayCartAdditionError()
            })
    }

    function showCartOverlay() {
        if (
            !document.body.classList.contains('template-cart') &&
            KROWN.settings.cart_action == 'overlay'
        ) {
            document.getElementById('site-cart-sidebar').show()
            setTimeout(() => {
                document
                    .querySelector('#site-cart-sidebar [data-js-close]')
                    .focus()
            }, 200)
        }
    }

    function monitorShippingDataChanges() {
        let previousShippingDataString = localStorage.getItem('docapp-shipping')
        let previousShippingData = previousShippingDataString
            ? JSON.parse(previousShippingDataString)
            : {}
        let previousUserLocation = previousShippingData.userLocation
            ? JSON.stringify(previousShippingData.userLocation)
            : null

        setInterval(function () {
            const currentShippingDataString =
                localStorage.getItem('docapp-shipping')
            const currentShippingData = currentShippingDataString
                ? JSON.parse(currentShippingDataString)
                : {}
            const currentUserLocation = currentShippingData.userLocation
                ? JSON.stringify(currentShippingData.userLocation)
                : null

            if (currentUserLocation !== previousUserLocation) {
                try {
                    if (
                        currentShippingData.userLocation &&
                        currentShippingData.userLocation.zip
                    ) {
                        const newUserZip = currentShippingData.userLocation.zip
                        localStorage.setItem('userZip', newUserZip)
                        console.log('User zip code updated to:', newUserZip)
                    }

                    const hasLocalDelivery = checkLocalDelivery()
                    localStorage.setItem(
                        'eligibility',
                        hasLocalDelivery.toString()
                    )
                    inCartAssemlyToggle(hasLocalDelivery)

                    previousUserLocation = currentUserLocation
                } catch (error) {
                    console.error('Error parsing shipping data:', error)
                }
            }
        }, 5000)
    }

    function checkLocalDelivery() {
        let hasLocalDelivery = false
        const dataInStorage = localStorage.getItem('docapp-shipping')
        const data = JSON.parse(dataInStorage)
        if (data.shippingOptions) {
            hasLocalDelivery = data.shippingOptions.some((rate) =>
                rate.name.includes('Local Delivery')
            )
        } else {
            hasLocalDelivery = false
        }
        return hasLocalDelivery
    }

    //toggle
    function loadingToggle(toggle) {
        let displayLoading = toggle ? 'block' : 'none'
        let displayContent = toggle ? 'none' : 'flex'

        document.getElementById('loadingSpinner').style.display = displayLoading
        document.getElementById('assembly-content').style.display =
            displayContent
    }

    function addtoCartToggle(toggle) {
        let displayToggle = toggle ? 'flex' : 'none'
        if (addButton) {
            addButton.style.display = displayToggle
        }
    }

    function inCartAssemlyToggle(toggle) {
        let displayAssemblyToggle = toggle ? 'flex' : 'none'
        let assemblyInCart = document.getElementById('assembly-content-cart')
        if (assemblyInCart) {
            assemblyInCart.style.display = displayAssemblyToggle
        }
        if (!assemblyAddedinCart) {
            displayAssemblyProduct(true)
        }
    }

    //error handling
    function displayPostalCodeMessage(message) {
        document.getElementById('assembly-content').style.display = 'flex'
        document.getElementById('addBothToCartButton').style.display = 'none'
        assemblyVariantInfo.innerHTML = `<span>${message}</span>`
    }

    function displayNoAssmemblyError() {
        loadingToggle(false)
        assemblyVariantInfo.innerHTML =
            '<span>Assembly service is temporarily unavailable. We’re working to bring it back soon. Thank you for your understanding.</span>'
        addtoCartToggle(false)
    }

    function displayServiceUnavailableError() {
        loadingToggle(false)
        assemblyVariantInfo.innerHTML =
            '<span>Assembly Service is not available in your area now. Learn More. 10002</span>'
        addtoCartToggle(false)
    }

    function displayCartAdditionError() {
        loadingToggle(false)
        assemblyVariantInfo.innerHTML =
            '<span>There was an error adding items to your cart. Please try again. 10004</span>'
        addtoCartToggle(false)
    }

    function _displayCartRemovalError() {
        loadingToggle(false)
        assemblyVariantInfo.innerHTML =
            '<span>There was an error removing items to your cart. Please try again. 10004</span>'
        addtoCartToggle(false)
    }

    function displayUnexpectedError() {
        loadingToggle(false)
        assemblyVariantInfo.innerHTML =
            '<span>An unexpected error occurred. Please try again or contact support. 10005</span>'
        addtoCartToggle(false)
        setEligibilityInLocalStorage(null)
    }
})
